'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const propTypes = {
    // type of the asset. Either 'image' or 'audio' at the moment.
    assetType: PropTypes.string.isRequired,

    // mimetypes to allow in the asset input. defaults to 'image/*'
    accept: PropTypes.string,

    // function to check if the mime type is valid.
    validateAssetType: PropTypes.func,

    // Defaults to 'Browse...'
    browseText: PropTypes.any, // string, or an array of react elements, or a react element

    // only show a button (not filename) defaults to false
    buttonOnly: PropTypes.bool,

    // full font-icon class name to display optionally.
    icon: PropTypes.string,

    iconOnly: PropTypes.bool,

    // self explanatory
    disabled: PropTypes.bool,

    // asset role to use for the single upload.
    assetRole: PropTypes.string,

    // value to show for filename, only displayed if buttonOnly is false
    value: PropTypes.string,

    // Change function. Should contain upload/request logic
    onChange: PropTypes.func.isRequired,
    onError: PropTypes.func,

    // called when file upload starts (onChange or onError is called when it ends)
    onLoadingStart: PropTypes.func,

    // id of the input element
    input_id: PropTypes.string,
};

const defaultProps = {
    assetRole: '',
    accept: '',
    browseText: 'Browse...',
    buttonOnly: false,
    icon: '',
    value: '',
    disabled: false
};

class SingleAssetInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onChange_ = this.onChange_.bind(this);
        this.resetValue = this.resetValue.bind(this);
    }

    // allows for re-selection of same file to trigger onChange
    resetValue(e) {
        e.target.value = null;
    }

    onChange_(/*ev*/) {
        const fileInput = ReactDOM.findDOMNode(this.refs.fileInput);
        const files = fileInput.files;
        if (files.length == 0) {
            return;
        }

        if (this.props.onLoadingStart) {
            this.props.onLoadingStart();
        }

        const file = files[0];
        if (this.props.validateAssetType && !this.props.validateAssetType(file)) {
            if (this.props.onError) {
                this.props.onError("The chosen file file is not of the correct type");
            }
            return;
        }
        
        if (file.size > 3000000) {
            if (this.props.onError) {
                this.props.onError("The chosen file is too large. Max is 3mb");
            }
            return;
        }

        const params = {
            assetType: this.props.assetType,
            assetRole: this.props.assetRole
        }

        this.props.onChange(params, files);
    }

    render() {
        let icon = null;
        if (this.props.icon) {
            icon = <span key="some-icon" className={`${this.props.icon} margin-right-sm`} aria-hidden="true" />;
        }

        let element;

        if (this.props.useLink) {
            element = (
                <a href="#" className="action-link a-file">
                    {this.props.browseText}
                    <input type="file"
                        id={this.props.input_id} ref="fileInput" 
                        accept={this.props.accept}
                        name={this.props.assetRole}
                        disabled={this.props.disabled}
                        onChange={this.onChange_}/>
                </a>
            );
        }
        else if (this.props.iconOnly) {
            element = (
                <div
                    role="button" 
                    className={"bare-text-button glyph " + this.props.additionalClasses + (this.props.disabled ? " disabled" : "")}
                    title={this.props.title ? this.props.title : ""}
                >
                    {icon}
                    <input type="file" 
                        id={this.props.input_id} 
                        accept={this.props.accept}
                        name={this.props.assetRole}
                        ref="fileInput"
                        disabled={this.props.disabled}
                        onClick={this.resetValue}
                        onChange={this.onChange_}/>
                </div>
            );
        }
        else if (this.props.buttonOnly) {
            element = (
                <div
                    role="button"
                    className={"btn btn-primary div-btn btn-file " + this.props.additionalClasses + (this.props.disabled ? " disabled" : "")}
                    title={this.props.title ? this.props.title : ""}
                >
                    <span>
                        {icon}
                        <span key="browse-text">{this.props.browseText}</span>
                    </span>
                    <input type="file" 
                        id={this.props.input_id} 
                        accept={this.props.accept}
                        name={this.props.assetRole}
                        ref="fileInput"
                        disabled={this.props.disabled}
                        onClick={this.resetValue}
                        onChange={this.onChange_}
                    />
                </div>
            );
        }
        else {
            element = (
                <div className="input-group">
                    <span className="input-group-btn">
                        <span
                            className={"btn btn-file gylph " + this.props.additionalClasses + (this.props.disabled ? " disabled" : "")}
                        >
                            {icon}
                            &nbsp;
                            {this.props.browseText}
                            <input type="file"
                                accept={this.props.accept}
                                name={this.props.assetRole}
                                ref="fileInput"
                                disabled={this.props.disabled}
                                onClick={this.resetValue}
                                onChange={this.onChange_}
                            />
                        </span>
                    </span>
                    <input
                        type="text"
                        role="presentation"
                        readOnly
                        className={"form-control "+(this.props.disabled ? "disabled" : "")}
                        disabled={this.props.disabled}
                        value={this.props.value}
                    />
                </div>
            );
        }

        return element;
    }
} // SingleAssetInput

SingleAssetInput.propTypes = propTypes;
SingleAssetInput.defaultProps = defaultProps;

module.exports = SingleAssetInput;
